import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("ip_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("ip_token"); setUser(false); });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ip_token", data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const adopt = useCallback((token, u) => { localStorage.setItem("ip_token", token); setUser(u); }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("ip_token");
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, login, logout, adopt }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
